import { ref, watchEffect } from 'vue';
import { sys } from 'zova';
export function $getZovaIcon(iconName) {
  return sys.meta.$icon.parseIconInfoSync(iconName);
}
export function $useZovaIcon(iconGetter) {
  const iconInfo = ref();
  watchEffect(() => {
    iconInfo.value = $getZovaIcon(iconGetter());
  });
  return {
    iconInfo
  };
}